module.exports = __webpack_public_path__ + "static/missing-01-min-7214c48a002b9ec16d8faa9875d145ce.jpg";